// extracted by mini-css-extract-plugin
export default {"container":"LegalGuardianUpdateEmail_container__t-kzW","container__successMessage":"LegalGuardianUpdateEmail_container__successMessage__M2-Jc"};